import { render, staticRenderFns } from "./PageCreate.vue?vue&type=template&id=dc8793c4&"
import script from "./PageCreate.vue?vue&type=script&lang=ts&"
export * from "./PageCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports